import Service from "./Service";
const baseurl = '/api/historia-enunciados-escala-abreviada-desarrollo';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    showByRan(id) {
        return Service.get(`${baseurl}/show-by-ran/${id}`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
}